<template>
  <div>
    <div
      class="map"
      ref="mapContainer"
      :style="{ display: state === 'map' ? 'block' : 'none', height }"
    ></div>
    <div
      class="roadview"
      ref="rvContainer"
      :style="{ display: state === 'map' ? 'none' : 'block', height }"
    ></div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";

export default {
  name: "Map",
  props: {
    state: {
      type: String,
      default: "map",
    },
    height: {
      type: String,
      default: "70%",
    },
    station: {
      type: Object,
      default: () => {
        return {
          lat: 37.404685,
          lng: 127.097472,
          povLat: null,
          povLng: null,
          povBearing: null,
          povFov: null,
          povTilt: null,
          povZoom: null,
        };
      },
    },
    zoom: {
      type: Number,
      default: 17,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    isControlledZoom: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    let map, marker, rv, rvMarker;
    watch(
      () => props.station,
      (newStation, oldStation) => {
        if (JSON.stringify(oldStation) === "{}") {
          if (window.naver && window.naver.maps) {
            initMap();
            initRv();
          } else {
            addScript();
          }
        } else {
          changePosition(newStation.lat, newStation.lng);
        }
      }
    );

    onMounted(() => {
      if (JSON.stringify(props.station) === "{}") {
        return;
      }
      if (window.naver && window.naver.maps) {
        initMap();
        initRv();
      } else {
        addScript();
      }
    });

    const addScript = () => {
      const script = document.createElement("script");
      /* global naver */
      script.onload = () => initMap();
      script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.VUE_APP_API_NAVER_MAP}&submodules=panorama`;
      document.head.appendChild(script);
    };

    let mapContainer = ref(null);
    let rvContainer = ref(null);
    const initMap = () => {
      /* 지도 생성 */
      const mapCenter = new naver.maps.LatLng(
        props.station.lat,
        props.station.lng
      );
      const mapOptions = {
        center: mapCenter,
        zoom: props.zoom,
        mapTypes: new naver.maps.MapTypeRegistry({
          normal: naver.maps.NaverStyleMapTypeOptions.getNormalMap({
            overlayType: "bg.ol.ts.lko",
          }),
        }),
        draggable: props.draggable,
        pinchZoom: props.isControlledZoom,
        scrollWheel: props.isControlledZoom,
        disableDoubleClickZoom: !props.isControlledZoom,
        disableDoubleTapZoom: !props.isControlledZoom,
        disableTwoFingerTapZoom: !props.isControlledZoom,
      };
      map = new naver.maps.Map(mapContainer.value, mapOptions);
      /* 지도 마커 */
      marker = new naver.maps.Marker({
        map,
        position: mapCenter,
      });
      marker.setMap(map);
      // 로드뷰 callback함수
      naver.maps.onJSContentLoaded = () => {
        initRv();
      };
    };

    /* 로드뷰 생성 */
    const initRv = () => {
      const rvCenter = new naver.maps.LatLng(
        props.station.lat,
        props.station.lng
      );
      const rvOptions = {
        position: rvCenter,
      };
      rv = new naver.maps.Panorama(rvContainer.value, rvOptions);
      // 로드뷰 marker
      rvMarker = new naver.maps.Marker({
        position: rvCenter,
        map: rv,
      });

      naver.maps.Event.addListener(rv, "init", function () {
        // 로드뷰 zoom
        rv.setZoom(0);
        // 로드뷰 marker가 화면 중앙에오도록 로드뷰의 viewport를 조정한다.
        setRvPov();
      });
      naver.maps.Event.addListener(rv, "pano_changed", setRvPov);
    };
    const setRvPov = () => {
      const projection = rv.getProjection();
      const viewpoint = projection.fromCoordToPov(rvMarker.getPosition());
      rv.setPov(viewpoint);
    };
    const changePosition = async (lat, lng) => {
      map.setCenter(new naver.maps.LatLng(lat, lng));
      marker.setPosition(new naver.maps.LatLng(lat, lng));
      rv.setPosition(new naver.maps.LatLng(lat, lng));
      rvMarker.setPosition(new naver.maps.LatLng(lat, lng));
    };

    return { mapContainer, rvContainer };
  },
};
</script>

<style lang="scss" scoped>
.map {
  position: absolute;
  width: 100%;
}
.roadview {
  position: absolute;
  width: 100%;
  display: none;
}
</style>
